import { render, staticRenderFns } from "./detailDiff.vue?vue&type=template&id=b295f864&scoped=true"
import script from "./detailDiff.vue?vue&type=script&lang=js"
export * from "./detailDiff.vue?vue&type=script&lang=js"
import style0 from "./detailDiff.vue?vue&type=style&index=0&id=b295f864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b295f864",
  null
  
)

export default component.exports